import { Trans } from '@lingui/react/macro';

import Box from '@/design_system/Box';
import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import Title from '@/design_system/Typography/Title';
import IconAssociate from '@/icons/Associate.svg';
import IconStore from '@/icons/Store.svg';
import { Workflow } from '@/models/workflow';

export const Stores = ({ workflow }: { workflow: Workflow }) => {
  return (
    <Box gap="1rem">
      <Stack>
        <Title as="h2">
          <Trans id="settings.workflows.workflow.scope.entities.title">Stores</Trans>
        </Title>
        <Paragraph size="200" color="secondary">
          <Trans id="settings.workflows.workflow.scope.entities.description">
            If configured, only these stores or groups of stores can use this workflow.
          </Trans>
        </Paragraph>
      </Stack>
      <EntitiesAndGroupsList entities={workflow.entities} entityGroups={workflow.entityGroups} />
    </Box>
  );
};

const EntitiesAndGroupsList = ({
  entities,
  entityGroups,
}: {
  entities: Workflow['entities'];
  entityGroups: Workflow['entityGroups'];
}) => {
  if (entities.length + entityGroups.length === 0) {
    return (
      <Paragraph size="100" color="secondary">
        <Trans id="settings.workflows.workflow.scope.entities.empty">All stores</Trans>
      </Paragraph>
    );
  }

  return (
    <Stack gap="0.25rem" alignItems="start" flexWrap="nowrap">
      {entityGroups.map((group) => (
        <Stack key={group.id} row gap="0.25rem" alignItems="center" flexWrap="nowrap">
          <IconAssociate
            style={{ fontSize: '1.25rem', color: 'var(--color-text-secondary-black)' }}
          />
          <Button variant="link-subtle" to={`/settings_beta/network/groups/${group.id}`}>
            <InlineText size="100" color="secondary">
              {group.name}
            </InlineText>
          </Button>
        </Stack>
      ))}
      {entities.map((entity) => (
        <Stack key={entity.id} row gap="0.25rem" alignItems="center" flexWrap="nowrap">
          <IconStore style={{ fontSize: '1.25rem', color: 'var(--color-text-secondary-black)' }} />
          <Button variant="link-subtle" to={`/settings_beta/network/entities/${entity.id}`}>
            <InlineText size="100" color="secondary">
              {entity.name}
            </InlineText>
          </Button>
        </Stack>
      ))}
    </Stack>
  );
};
